import PropTypes from "prop-types";
import React from "react";

import DuplicateDestinationForm from "v2/components/responsive/DuplicateDestinationForm";

const DuplicateDestinationPage = (props, context) => {
  const {location: {query}, params: {date, id, routeId}, router} = context;
  return (
    <DuplicateDestinationForm
      onCancel={(evt) => {
        evt.preventDefault();
        router.push({
          pathname: `/${date}/${routeId}/${id}`,
          query,
        });
      }} />
  );
};

DuplicateDestinationPage.contextTypes = {
  location: PropTypes.object,
  params: PropTypes.shape({
    date: PropTypes.string.isRequired,
    id: PropTypes.string.isRequired,
    routeId: PropTypes.string.isRequired,
  }),
  router: PropTypes.object,
};

export default DuplicateDestinationPage;



/** WEBPACK FOOTER **
 ** ./src/app/v2/pages/DuplicateDestinationPage.js
 **/